import { X } from 'lucide-react';
import { TooltipRenderProps } from 'react-joyride';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/ui/utils';

export function CustomTooltip({
  backProps,
  closeProps,
  continuous,
  index,
  isLastStep,
  primaryProps,
  skipProps,
  step,
  tooltipProps,
}: TooltipRenderProps) {
  const isStringContent = typeof step.content === 'string';

  return (
    <div
      {...tooltipProps}
      className={cn(
        'relative rounded-lg bg-white p-4 shadow-lg',
        'min-w-[300px] max-w-[400px]'
      )}
    >
      <Button
        variant="ghost"
        size="icon"
        className="absolute right-2 top-2"
        {...closeProps}
      >
        <X className="h-4 w-4" />
      </Button>

      {step.title && (
        <h4 className="mb-2 text-lg font-semibold">{step.title}</h4>
      )}

      {isStringContent ? (
        <div
          className="mb-4 text-sm text-muted-foreground"
          dangerouslySetInnerHTML={{ __html: step.content as string }}
        />
      ) : (
        <div className="mb-4 text-sm text-muted-foreground">{step.content}</div>
      )}

      <div className="flex items-center justify-between gap-2">
        {!isLastStep && (
          <Button variant="ghost" size="sm" {...skipProps}>
            Skip
          </Button>
        )}
        <div className="ml-auto flex items-center gap-2">
          {index > 0 && (
            <Button variant="outline" size="sm" {...backProps}>
              Back
            </Button>
          )}
          {continuous && (
            <Button variant="default" size="sm" {...primaryProps}>
              {isLastStep ? 'Done' : 'Next'}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
